<div>
  <div class="flex">
    <custom-label *ngIf="placeholder" [placeholder]="placeholder"></custom-label>
    <div *ngIf="isRequired" class="text-red-500 ml-1 mt-1">*</div>
  </div>
  <p-multiSelect
    [options]="multiSelectValues"
    [optionLabel]="label"
    [optionValue]="optionValue"
    [filter]="filterBy ? true : false"
    [filterBy]="filterBy"
    [placeholder]="dropdownMessage"
    [formControl]="value"
  >
    <ng-template let-value let-index="index" pTemplate="selectedItems" *ngIf="typeTemplate !== 'none'">
      <div class="inline-flex align-items-center gap-2 px-1" *ngFor="let option of value; let last = last">
        <div *ngIf="option?.hexadecimal && option.name !== dontApply" class="square" [ngStyle]="{'background-color': '#' + option?.hexadecimal}"></div>
        <div *ngIf="typeTemplate === 'colors'">{{getCorrectProperty(option, 'name', last) }}</div>
        <div *ngIf="typeTemplate === 'measurementSystemDetail'">{{getCorrectProperty(option, 'value', last)}}</div>
      </div>
      <div *ngIf="!value || value.length === 0">{{dropdownMessage}}</div>
    </ng-template>

    <ng-template let-option pTemplate="item" >
      <div *ngIf="typeTemplate !== 'none'" class="flex align-items-center gap-2">
        <div *ngIf="option?.hexadecimal && option.name !== 'No Aplica'" class="square" [ngStyle]="{'background-color': '#' + option?.hexadecimal}"></div>
          <div *ngIf="typeTemplate === 'colors'">{{ getCorrectProperty(option, 'name', false) }}</div>
          <div *ngIf="typeTemplate === 'measurementSystemDetail'">{{getCorrectProperty(option, 'value', false)}}</div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer" *ngIf="typeTemplate !== 'none'">
        <div class="py-2 px-3">
            <b>
            {{ value ? value.value!.length : 0 }}
            </b>
            item{{ (value ? value.value!.length : 0) > 1 ? 's' : '' }} selected.
        </div>
    </ng-template>
  </p-multiSelect>
</div>

